import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  drivers: [],
  loading: true,
}

const driversSlice = createSlice({
  name: 'drivers',
  initialState,
  reducers: {
    getDriversRequest(state) {
      state.loading = true
    },
    getDriversReply(state, { payload }) {
      state.loading = false

      if (payload) {
        state.drivers = payload.drivers
      }
    },
  },
})

export const { getDriversRequest, getDriversReply } = driversSlice.actions

export default driversSlice.reducer
